import React from "react";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
// Modules
import { Container, Row, Col } from "react-bootstrap";
import imgss from "../assets/images/jpg/howTerpnashWorks.jpg";
import bannerLeftImg from "../assets/images/Full_map.svg";
import bannerLeftImg1 from "../assets/images/India_new_img.svg";
import bannerLeftImg2 from "../assets/images/Australia.svg";
import bannerLeftImg3 from "../assets/images/EU.svg";
import bannerLeftImg4 from "../assets/images/USA.svg";
import bannerLeftImg5 from "../assets/images/last.svg";
import bannerLeftImg6 from "../assets/images/India_new_loc.svg";
import bannerLeftImg7 from "../assets/images/Australia_location.svg";
import bannerLeftImg8 from "../assets/images/EU_new_loc.svg";
import bannerLeftImg9 from "../assets/images/USA_new_icon.svg";
// import bannerLeftImg5 from "../assets/images/last.svg";
import CustomSvg from "./CustomSvg";
import ImageGallery from "react-image-gallery";

export default function Homebanner() {
  var settings = {
    dots: false,
    prevArrow: "",
    nextArrow: "",
    arrows: false,
    autoplay: true,
    fade: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };


  return (
    <section className=" position-relative banner-top">
      {/* <div className="banner-overlay"></div> */}
      <Container>
        <Row className="banner-top">
          <Col lg={5} md={12} sm={12} className="my-auto">
            <div className="banner-content bannertext">
              <h3>Terpnash</h3>
              <p className="mt-2">
                World’s first global distributor of physical art prints and digital editions of original artwork by artists and photographers.
              </p>
              <div className="btnm">
                <a
                  href="https://market.terpnash.com/"
                  rel="noreferrer"
                  target={"_blank"}
                  className="Musebtn1 "
                >
                  Explore
                </a>
                <a
                  href="https://market.terpnash.com/users/register"
                  rel="noreferrer"
                  target={"_blank"}
                  className="Musebtn2 "
                >
                  Create
                </a>
              </div>
            </div>
          </Col>

          <Col lg={7} md={12} sm={12}>
            {/* <div className="sliderBox">
              <ImageGallery autoPlay={true} items={images} />
            </div> */}
            <div className="sliderBoxNew">
               {/* <CustomSvg /> */}
                <img src={bannerLeftImg} className="banner_left_img" alt="" />
             <div className="left_img1"><img src={bannerLeftImg1} className="zoom-on-hover" alt="" /></div>
             <div className="left_img2"><img src={bannerLeftImg2} className="zoom-on-hover" alt="" /></div>
             <div className="left_img3"><img src={bannerLeftImg3} className="zoom-on-hover" alt="" /></div>
             <div className="left_img4 zoom-on-hover1"><img src={bannerLeftImg4} className="" alt="" />
             <img src={bannerLeftImg5} className="img_5" alt="" />
             </div>
              {/* <div className="left_img5"><img src={bannerLeftImg5} className="zoom-on-hover" alt="" /></div> */}
              <div className="left_img6">
                <img src={bannerLeftImg6} className="animate-slide-down delay-1" alt="" />
              </div>
              <div className="left_img7">
                <img src={bannerLeftImg7} className="animate-slide-down delay-2" alt="" />
              </div>
              <div className="left_img8">
                <img src={bannerLeftImg8} className="animate-slide-down delay-3" alt="" />
              </div>
              <div className="left_img9">
                <img src={bannerLeftImg9} className="animate-slide-down delay-4" alt="" />
              </div>
             
             {/* <div><img src={bannerLeftImg2} alt="" /></div>
             <div><img src={bannerLeftImg3} alt="" /></div>
             <div><img src={bannerLeftImg4} alt="" /></div>
             <div><img src={bannerLeftImg5} alt="" /></div> */}
            
             {/* <div><img src={bannerLeftImg7} alt="" /></div>
             <div><img src={bannerLeftImg8} alt="" /></div>
             <div><img src={bannerLeftImg9} alt="" /></div> */}

            </div>
          
          </Col>
        </Row>
      </Container>
    </section>
  );
}
